import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-deletBtn",
  "use": "icon-deletBtn-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-deletBtn\"><defs><style></style></defs><path d=\"M374.268 393.957h64.847V786.29h-64.847zm215.313 0h64.847V786.29H589.58zM240.06 5.42h548.759v64.847h-548.76zM71.35 162.388h885.817v64.846H71.35z\" /><path d=\"M744.202 1017.859H284.495c-71.17 0-128.971-57.803-128.971-128.971V194.72h64.846v694.167c0 35.403 28.72 64.124 64.125 64.124h459.707c35.404 0 64.124-28.72 64.124-64.124V194.72h64.847v694.167c0 71.168-57.802 128.97-128.971 128.97z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol